<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!timeline" class="dw-empty">No alerts in this period.</div>
    <template v-else>
      <fi-timeline-chart
        :rows="timeline.rows"
        :series="timeline.series"
        :height="240"
        chart-label="Alerts per day by type"
      />
      <div v-if="truncated" class="dw-truncation-note">
        Chart reflects the {{ resultsLimit.toLocaleString() }} most recent alerts in this range.
      </div>
    </template>
  </div>
</template>

<script>
import FiTimelineChart from '../charts/fi_timeline_chart.vue'
import {
  alertTypesOverTime, capSeriesColumns, timelineFromGviz,
  TYPE_COLOR_PALETTE, TYPE_COLOR_PALETTE_DARK,
  OTHER_TYPE_COLOR, OTHER_TYPE_COLOR_DARK,
} from '../../utils/alerts_analytics'

export default {
  name: 'widget_alerts_by_type',
  components: { FiTimelineChart },
  props: {
    // shared across every alert-detail widget by main_dashboard.vue's
    // load_alerts_detail(), so this widget costs no API call of its own.
    alerts: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    // true when the API capped the shared alert fetch at its newest-first
    // results_limit -- the chart then only covers that slice.
    truncated: { type: Boolean, default: false },
    resultsLimit: { type: Number, default: 0 },
  },
  computed: {
    isMidnight() {
      return this.$store.state.profile.site_theme === 'midnight'
    },
    chartData() {
      // capped to the palette's 8 slots -- a half-width card doesn't have
      // room for a legible legend beyond that, so excess types fold into
      // "Other" rather than stretching the palette further.
      return capSeriesColumns(alertTypesOverTime(this.alerts), TYPE_COLOR_PALETTE.length)
    },
    timeline() {
      // dark mode is selected, never an automatic flip: both palettes are
      // separately validated (see utils/alerts_analytics.js)
      return timelineFromGviz(
        this.chartData,
        this.isMidnight ? TYPE_COLOR_PALETTE_DARK : TYPE_COLOR_PALETTE,
        this.isMidnight ? OTHER_TYPE_COLOR_DARK : OTHER_TYPE_COLOR,
      )
    },
  },
}
</script>
